import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_andean_touch: FaireCollectionEntity = {
  token: "col_andean-touch",
  type: "collection",
  name: "Andean Touch",
  description: "Handcrafted textures inspired by South American artisanship.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  season: "new",
  itemCount: 15,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
